
export const serverUrl={
    aws:'https://pyd0xvkp5g.execute-api.ap-south-1.amazonaws.com/default',
    web:'https://web.alistetechnologies.com',
    sub:'https://subscriptioncloud.alistetechnologies.com',
    thermoAws:'https://q2c544kuqd.execute-api.ap-south-1.amazonaws.com',
    weatherAws:'https://hp92ovh6r0.execute-api.ap-south-1.amazonaws.com/default',
    environAws:'https://mzcdl7akp0.execute-api.ap-south-1.amazonaws.com',
    megaController:'https://v1yebqn9j8.execute-api.ap-south-1.amazonaws.com/default',
    doorSensor:'https://pczpa0az51.execute-api.ap-south-1.amazonaws.com/default',
    mqttConnectionStatus:'https://keiozfbox5.execute-api.ap-south-1.amazonaws.com/default',
    subTest:'https://test.alistetechnologies.com:9443',
    vrvController:'https://vrvcontroller.main.aliste.io',
}

export const pages = {
    schedulePage:'schedule',
    megaControllerPage:'megacontroller',
}